import firebase from "@firebase/app";
import "@firebase/auth";
import secure_axios from "../../services/secure_axios";
import 'firebase/storage';

const initialState = ()=>({
  fbuser: null,
  fbuserdata: {},
  sessionAPI: null,
  localAPI: null,
  factsuser: null,
  isloggedIn: false,
  company: null,
  userProfile:{},
  employees:null,
  useLocalAPI: false,
  // isAuthenticated : false,
  // notifications: [],
});
const state = initialState();

// async function storeOrUpdateToken(userId, deviceIdentifier, token) {
//   const userTokensRef = firebase.firestore().collection('users').doc(userId).collection('tokens');
//   const deviceTokenRef = userTokensRef.doc(deviceIdentifier);

//   const doc = await deviceTokenRef.get();
//   if (doc.exists) {
//     await deviceTokenRef.update({ token });
//   } else {
//     await deviceTokenRef.set({ token });
//   }
// }

// async function removeToken(userId, deviceIdentifier) {
//   const userTokensRef = firebase.firestore().collection('users').doc(userId).collection('tokens');
//   await userTokensRef.doc(deviceIdentifier).delete();
// }

const getters = {
  fbuser: (state) => state.fbuser,
  fbuserdata: (state) => state.fbuserdata,
  sessionAPI: (state) => state.sessionAPI,
  localAPI:(state) => state.localAPI+'/',
  perferedAPI: (state) => state.useLocalAPI?state.localAPI+'/':state.sessionAPI,
  factsuser: (state) => state.factsuser,
  isLoggedIn: (state) => state.isloggedIn,
  company:(state) => state.company,
  userProfile:(state) => state.userProfile,
  employees:(state) => state.employees,
  anyAttLoc:(state) => state.factsuser.USER_UD_LABEL5 === "1"


  // notifications: (state) => state.notifications
};

const mutations = {
  setfbUser(state, payload) {
    state.fbuser = payload;
  },
  setfbUserData(state, payload) {
    state.fbuserdata = payload;
  },
  setSessionAPI(state, payload) {
    state.sessionAPI = payload;
  },
  setlocalAPI(state, payload) {
    state.localAPI = payload;
  },
  setAPIPreference(state, useLocal) {
    state.useLocalAPI = useLocal;
  },
  setfactsUser(state, payload) {
    state.factsuser = payload;
  },
  setcompany(state,payload){
    state.company = payload;
  },
  // setnotification(state, payload){
  //   state.notifications = payload;
  // },
  setuserProfile(state,payload){
    state.userProfile= payload;
  },
  setemployees(state,payload){
    state.employees = payload;
  },
  // RESET_STATE(state) {
  //   Object.keys(state).forEach(key => {
  //     delete state[key];
  //   });  },
  RESET_STATE(state) {
    const newState = initialState();
    Object.keys(newState).forEach(key => {
      state[key] = newState[key];
    });
  },
};

const actions = {
  signUserUp({ commit }, payload) {
    commit("setLoading", true);
    commit("clearError");
    firebase
      .auth()
      .createUserWithEmailAndPassword(payload.email, payload.password)
      .then((response) => {
        commit("setfbUser", response.user);
        var duid = response.user.uid;
        return duid;
      })
      .catch((error) => {
        commit("setLoading", false);
        commit("setError", error);
      })

      .then((duid) => {
        const db = firebase.firestore();

        const useremail = payload.email;
        const createdAt = new Date();
        const firstname = payload.firstName;
        const lastname = payload.lastName;
        const company = payload.company;

        db.collection("fb_users")
          .doc(duid)
          .set({
            useremail,
            firstname,
            lastname,
            createdAt,
            duid,
            company,
          });

        if (duid != "") {
          commit("setMsgColor", "limegreen");
          commit("setMsgHeading", "Success!");
          commit(
            "setMsgText",
            `Successfully registered. Please send the following authentication code to the admin.
              Authentication code: ${duid}`
          );
          commit("setLoading", false);
          commit("setShowPop", true);
        }
      });
  },
  async signUserIn({ dispatch }, payload) {
    try {
      const duid = await dispatch('fbSignIn', payload);
      const company = await dispatch('getFbDoc', duid);
      const sessionapi = await dispatch('setSessionAPI', {company});
      await dispatch('factsSignIn', { duid, sessionapi });
    } catch (error) {
      console.error("Sign-in process error:", error);
    }
  },
  async fbSignIn({ commit }, user_payload) {
    commit("setLoading", true);
    try {
      const fbUser = await firebase
        .auth()
        .signInWithEmailAndPassword(user_payload.email, user_payload.password);
      commit("setfbUser", fbUser.user);
  
      const idToken = await fbUser.user.getIdToken(true);
      secure_axios.defaults.headers.common['Authorization'] = "token " + idToken;
      commit("setauthToken", idToken);
  
      return fbUser.user.uid;
    } catch (error) {
      console.error("Firebase sign-in error:", error);
      commit("setError", error);
      throw error;
    } finally {
      // commit("setLoading", false);
    }
  },
  async getFbDoc({ commit }, duid) {
    const db = firebase.firestore();
    try {
      const snapshot = await db.collection("fb_users").doc(duid).get();
      const fb_userdata = snapshot.data();
      commit("setfbUserData", fb_userdata);
  
      const company = fb_userdata.company;
      commit("setcompany", company);
  
      return company;
    } catch (error) {
      console.error("Firebase document fetch error:", error);
      throw error;
    }
  },
  updateAPIPreference({ commit }, { useLocal, localAPI }) {
    // console.log("localAPI:",localAPI);
    commit('setAPIPreference', useLocal);
    if (localAPI) 
    commit('setlocalAPI', localAPI);    
  },
  setSessionAPI({ commit }, { company = null, localSessionAPI = null }) {
    let sessionapi;

    if (localSessionAPI) {
      // Use the provided localSessionAPI
      sessionapi = localSessionAPI;
    } else {
      const selectedCompany = company || state.company;
      const sessionApis = {
        "Skymat": "https://skymatfactsapi.ngrok.io/",
        "Triton": "https://tritonfactsapi.ngrok.io/"
        };
      sessionapi = sessionApis[selectedCompany] || "";
    }

    commit("setSessionAPI", sessionapi);
  
    secure_axios.defaults.headers.common['company'] = company || state.company;
    return sessionapi;
  },
  async factsSignIn({ commit ,dispatch}, { duid, sessionapi }) {
    try {
      commit("setLoading", true);
      const factsResponse = await secure_axios.get(`${sessionapi}user/${duid}`);
      const factsUser = factsResponse.data.user;
      commit("setfactsUser", factsUser);
      dispatch("get_employee", { employ_id: factsUser?.USER_EMP_DOCNO })
      commit("setLoading", false);
    } catch (error) {
      console.error("Facts API sign-in error:", error);
      throw error;
    }
  },
  get_employee({ commit,getters }, payload) {      
    commit("setLoading", true); 
    commit("clearError");  

    const employ_id = payload.employ_id;
    
    // secure_axios
    secure_axios
      .get(`${getters.sessionAPI}userprofile?employ_id=${employ_id}`)
      .then((response) => {          
        commit("setuserProfile", response.data.employee);
        commit("setLoading", false);
      })
      .catch((error) => {
        commit("setLoading", false);
        commit("setError", error);
      });
  },
  get_employees({ commit,getters }, payload) {      
    commit("setLoading", true); 
    commit("clearError");  

    const employ_id = payload.employ_id;
    const EMPMST_DESG_DOCNO = payload.EMPMST_DESG_DOCNO;
    const dep = payload.dep
    const USER_LOGINID = payload.USER_LOGINID
    // secure_axios
    secure_axios
      .get(`${getters.sessionAPI}employees?employ_id=${employ_id}&EMPMST_DESG_DOCNO=${EMPMST_DESG_DOCNO}&dep=${dep}&USER_LOGINID=${USER_LOGINID}`)
      .then((response) => {          
        commit("setemployees", response.data.employees);
        commit("setLoading", false);
      })
      .catch((error) => {
        commit("setLoading", false);
        commit("setError", error);
      });
  },  
  async isAuthenticated() {
    return new Promise((resolve) => {
      const unsubscribe = firebase.auth().onAuthStateChanged((user) => {
        resolve(user !== null); // Resolve based on truthiness of user object
        unsubscribe(); // Unsubscribe to avoid memory leaks
      });
    });
  },
  refreshUser({ commit }, payload) {
    commit("setLoading", true);
    commit("clearError");
    secure_axios.get(getters.sessionAPI + "user/" + payload).then((response) => {
      commit("setfactsUser", response.data.user);
      commit("setLoading", false);
      commit("setError", response.data);
    });
  },

  signUserOut({ commit }) {
    commit("setLoading", true);
    commit("clearError");
    firebase
      .auth()
      .signOut()
      .then(commit("setfbUser", null))
      .then(commit("setfactsUser", null))
      .then(commit("setauthToken",null))
      .then(commit("setLoading", false))
      .catch((error) => {
        commit("setLoading", false);
        commit("setError", error);
      });
  },
  
};

export default {
  namespace: true,
  state,
  getters,
  actions,
  mutations,
};


// signUserIn({ commit }, payload) {
  //   commit("setLoading", true);
  //   commit("clearError");
  //   const db = firebase.firestore();

  //   async function fbSignIn(user_payload) {
  //     const fbUser = await firebase
  //       .auth()
  //       .signInWithEmailAndPassword(user_payload.email, user_payload.password);
  //     commit("setfbUser", fbUser.user);
  //     const duid = fbUser.user.uid;
  //     const idToken = firebase
  //       .auth()
  //       .currentUser
  //       .getIdToken(/* forceRefresh */ true)
  //       .then(function(idToken) {
  //         secure_axios.defaults.headers.common['Authorization'] = "token "+idToken
  //         commit("setauthToken",idToken)
  //         // console.log(idToken) 
  //         }).catch(function(error) {
  //         // Handle error
  //         console.log(error)
  //         commit("seterror",idToken)
  //         });      
  //     return duid;
  //   }

  //   async function getFbDoc() {
  //     const duid = await fbSignIn(payload);
  //     const snapshot = await db
  //       .collection("fb_users")
  //       .doc(duid)
  //       .get();
  //     const fb_userdata = await snapshot.data();
  //     commit("setfbUserData", fb_userdata)
  //     var company = fb_userdata.company;
  //     commit("setcompany",company)
  //     //console.log(fb_userdata);
  //     return company;
  //   }   

  //   async function setSessionAPI() {
  //     const company = await getFbDoc();
  //     secure_axios.defaults.headers.common['company'] = company
  //     if (company == "Skymat") {
  //       const sessionapi = "https://skymatfactsapi.ngrok.io/";
  //       commit("setSessionAPI", sessionapi);
  //       return sessionapi
  //     } else if (company == "Triton") {
  //       const sessionapi = "https://tritonfactsapi.ngrok.io/";
  //       commit("setSessionAPI", sessionapi);
  //       return sessionapi
  //     }      
  //   }

  //   async function factsSignIn() {
  //     const sessionapi = await setSessionAPI();
  //     const duid = await fbSignIn(payload);
  //     const factsResponse = await secure_axios.get(sessionapi + "user/" + duid);
  //     const facstUser = factsResponse.data.user;      
  //     commit("setfactsUser", facstUser);
  //     commit("setLoading", false);
  //     commit("setError", factsResponse.data.message); 
  //   }

  //   factsSignIn().catch((error) => {
  //     commit("setLoading", false);
  //     commit("setError", error);
  //   });
  // },


  // async getNotification({ state }){
  //   // let notifications = [];
  //   const db = firebase.firestore();
  //   const database = await db
  //       .collection("facts_app_banners") 
  //       .where("isActive", "==", true)
  //       .orderBy("createdAt","desc")    
  //   const dbresult = await database.get(); 
  //   dbresult.forEach((doc)=>{
  //     const data = {
  //       id:doc.data().Id,
  //       title:doc.data().title,
  //       message:doc.data().Message,
  //       src:doc.data().src,
  //       company:doc.data().Company,
  //       validFrom:doc.data().validFrom,
  //       validTill:doc.data().validTill,
  //       createdAt:doc.data().createdAt,
  //     };
  //     // notifications.push(data)
  //      state.notifications.push(data)
  //   })
    // console.log(notifications); 
      // commit("setnotification",notifications);
    // return notifications
  // },
  // getToken({commit},payload){
  //   firebase.auth().currentUser.getIdToken(/* forceRefresh */ true).then(function(idToken) {
  //     // Send token to your backend via HTTPS
  //     // ...
  //   }).catch(function(error) {
  //     // Handle error
  //   });
  // },
